
<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="autresInformations.nbOffresRecues"
    [label]="step6.getnboffresrecues" [type]="'number'" [rule]="'min_0|max_999'" [name]="getUid() + '_SepAtt_nbOffresRecues'">
</app-form-input>
<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="autresInformations.informations"
    [label]="step6.getinformations" [type]="'text'" [rule]="'minSize_5|maxSize_2000'" [name]="getUid() + '_SepAtt_informations'">
</app-form-input>
{{ step6.getspan14 | translate }}